import type {NotificationIntegrationConfigComponentProps} from '@cohort/merchants/apps';
import DynamicKeyValueInput from '@cohort/merchants/components/form/v2/DynamicKeyValueInput';
import SelectInput from '@cohort/merchants/components/form/v2/SelectInput';
import type {SelectOption} from '@cohort/merchants/components/form/v2/SelectPicker';
import Textarea from '@cohort/merchants/components/form/v2/Textarea';
import UrlInput from '@cohort/merchants/components/form/v2/UrlInput';
import {CohortCustomRequestNotificationHttpMethodSchema} from '@cohort/shared/schema/apps/cohort/notifications/customRequest';
import {useController} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

const CohortCustomRequestNotificationIntegrationConfigComponent: React.FC<
  NotificationIntegrationConfigComponentProps
> = ({control, register}) => {
  const {t} = useTranslation('app-cohort', {
    keyPrefix: 'notificationIntegrations.custom-request.configComponent',
  });
  const {field: httpMethod} = useController({
    control,
    name: 'notificationIntegrationConfig.httpMethod',
  });

  const httpMethodsOptions: Array<SelectOption> =
    CohortCustomRequestNotificationHttpMethodSchema.options.map(option => ({
      value: option,
      label: option,
    }));

  return (
    <div className="space-y-6">
      <div className="w-2/5">
        <SelectInput
          name="notificationIntegrationConfig.httpMethod"
          label={t('labelHttpMethod')}
          register={register}
          control={control}
          displayMode="expand"
          options={httpMethodsOptions}
        />
      </div>
      <UrlInput
        name="notificationIntegrationConfig.url"
        label={t('labelUrl')}
        register={register}
        control={control}
      />
      {!['GET', 'DELETE'].includes(httpMethod.value) && (
        <Textarea
          name="notificationIntegrationConfig.body"
          label={t('labelBody')}
          rows={5}
          register={register}
          control={control}
          placeholder={t('placeholderBody')}
        />
      )}
      <div>
        <DynamicKeyValueInput
          name="notificationIntegrationConfig.headers"
          control={control}
          register={register}
          labels={{
            title: t('headersTitle'),
            addBtn: t('addAnotherItem'),
            key: t('headersKey'),
            value: t('headersValue'),
          }}
        />
      </div>
    </div>
  );
};

export default CohortCustomRequestNotificationIntegrationConfigComponent;
